<div class="tabs">
  <button class="report-tab-button"
          *ngFor="let tab of tabs"
          [ngClass]="{ 'active': tab.name === activeTab }"
          (click)="changeActiveTab(tab)">{{ tab.name | translate }}
    <span class="report-tab-count">{{ tab.name === activeTab ? activeCount : tab.count }}</span>
  </button>
</div>
